import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  style: {"enable-background":"new 0 0 512 512"},
  viewBox: "0 0 512 512"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M469.103 85.629 433.76 50.286 151.935 332.111l-79.794-67.134-28.929 34.383-31.054 36.909 141.594 125.8 345.895-345.895z",
  style: {"fill":"#43b05c"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M469.103 85.629 433.76 50.286 151.935 332.111l-79.794-67.134-28.929 34.383 112.345 99.815z",
  style: {"fill":"#00a65d"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", { d: "M154.106 474.068 0 337.15l71.08-84.482 80.345 67.597L433.76 37.932l78.24 78.24-357.894 357.896zM24.317 335.386l129.081 114.683 333.895-333.896-53.534-53.533-281.315 281.315-79.242-66.67-48.885 58.101z" }, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }